import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { NEWS_DATA } from '../../../data/siteData';

export const LatestNewsBar: React.FC = () => {
  const latest = NEWS_DATA[0];
  if (!latest) return null;

  return (
    <aside
      className="spaq-news-strip bg-white border-y border-[#DCE4EA] text-[#122331]"
      aria-label="最新のお知らせ"
    >
      <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-12 py-3.5 sm:py-4 flex flex-col sm:flex-row sm:items-center justify-between gap-2.5 sm:gap-6 text-xs sm:text-sm">
        <div className="flex flex-wrap items-center gap-3 sm:gap-6 min-w-0 flex-1">
          <div className="flex items-center gap-3 shrink-0">
            <span className="font-bold tracking-wider text-[11px] sm:text-xs text-[#122331] uppercase">
              LATEST NEWS
            </span>
            <time
              className="font-mono text-[11px] sm:text-xs text-[#526372]"
              dateTime={latest.date.replaceAll('.', '-')}
            >
              {latest.date}
            </time>
          </div>
          <Link
            to={`/news/${latest.slug}`}
            className="text-[#122331] hover:text-[#23A6C4] transition-colors truncate font-normal text-xs sm:text-sm min-w-0 flex-1"
          >
            {latest.title}
          </Link>
        </div>

        <Link
          to="/news"
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#087C96] hover:text-[#23A6C4] transition-colors shrink-0 self-end sm:self-auto"
        >
          <span>一覧へ</span>
          <ArrowRight className="w-3.5 h-3.5" aria-hidden="true" />
        </Link>
      </div>
    </aside>
  );
};
